import { render, staticRenderFns } from "./IrrigatorProfileEventsList.vue?vue&type=template&id=1dd40c3f&"
import script from "./IrrigatorProfileEventsList.vue?vue&type=script&lang=js&"
export * from "./IrrigatorProfileEventsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports